<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div class="singleColumnLayout" [class.printable-mode]="isPrintable">
  <div *ngIf="isPrintable">
    <div class="center-button">
      <button
        mat-raised-button
        color="primary"
        (click)="clickPrint()">
        <fa-icon [icon]="['far', 'print']"></fa-icon>
        Print Form
      </button>
    </div>
    <div class="header-print">
      <div>
        <h2 class="tittle-header-print">
          Referral: <span class="tittle-name-header-print"> {{student.firstName + ' ' + student.lastName}} </span>
        </h2>
        <span class="subtitle-header-print">
          {{ incident.reporter.firstName + ' ' + incident.reporter.lastName }}
          {{ incidentTypeObject ? ' / ' + incidentTypeObject.display : '' }}
      </span>
      </div>
      <div>
        <div class="status-referral-print">
          <span>
            Finalized Referral
          </span>
        </div>
      </div>
    </div>
  </div>
  <form [formGroup]="referralForm">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title class="card-title">Referral For</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="three-column-layout">
        <div class="one-third">
          <mat-form-field>
            <mat-label>Student</mat-label>
            <input [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Student" [value]="student.firstName + ' ' + student.lastName" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Grade</mat-label>
            <input [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Grade" [value]="student.grade" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Incident Number</mat-label>
            <input  [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Date" [value]="incident.incidentNumber" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Guardian Name</mat-label>
            <input  [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Guardian" [value]="student.guardians[0] ? (student?.guardians[0]?.firstName + ' ' + student?.guardians[0]?.lastName) : 'no guardian'" />
          </mat-form-field>
        </div>
        <div class="one-third">
          <mat-form-field>
            <mat-label>Student Id</mat-label>
            <input  [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Student" [value]="student.studentExtId" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Incident Date</mat-label>
            <input  [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Date" [value]="DateUtil.convertToDisplayDate(incident.date)" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Reporter/Referral By</mat-label>
            <input  [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Referral By" [value]="incident.reporter.firstName + ' ' + incident.reporter.lastName" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Guardian Phone</mat-label>
            <input  [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Guardian" [value]="student.guardians[0] ? (student.guardians[0]?.phone) : 'no guardian'" />
          </mat-form-field>
        </div>
        <div class="one-third">
          <mat-form-field>
            <mat-label>Student School</mat-label>
            <input [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Student" [value]="school?.name" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Incident Place</mat-label>
            <input [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Student" [value]="incidentPlace" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Guardian Email</mat-label>
            <input [disabled]="!isPrintable" [readonly]="isPrintable" matInput placeholder="Student" [value]="(student?.guardians[0]?.email) || 'no guardian'" />
          </mat-form-field>
        </div>
      </div>
      <div class="one-column-layout">
        <mat-form-field class="full-width-input-incident">
          <mat-label>Incident Description</mat-label>
          <textarea
            [disabled]="!isPrintable"
            [readonly]="isPrintable"
            matInput placeholder="Incident Description"
            [value]="incident.description"></textarea>
        </mat-form-field>
      </div>
      <div class="three-column-layout">
        <div class="one-third">
          <mat-form-field>
            <mat-label>Student With Special Needs</mat-label>
            <input type="text" matInput formControlName="studentWithSpecialNeedsId" [matAutocomplete]="auto">
            <mat-icon matSuffix class="icon" *ngIf="!referralForm.get('studentWithSpecialNeedsId').value">arrow_drop_down</mat-icon>
            <button
              matSuffix
              class="icon"
              *ngIf="referralForm.get('studentWithSpecialNeedsId').value"
              mat-icon-button
              aria-label="Clear"
              (click)="onClear('studentWithSpecialNeedsId')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'studentWithSpecialNeedsOptions')" showPanel="true">
              <mat-option *ngFor="let option of filteredSpecialNeeds | async" [value]="option.value">
                {{option.display}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Motivation</mat-label>
            <input type="text" matInput formControlName="motivationId" [matAutocomplete]="autoMotivation">
            <mat-icon matSuffix class="icon" *ngIf="!referralForm.get('motivationId').value">arrow_drop_down</mat-icon>
            <button
              matSuffix
              class="icon"
              *ngIf="referralForm.get('motivationId').value"
              mat-icon-button
              aria-label="Clear"
              (click)="onClear('motivationId')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoMotivation="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'motivationOptions')" showPanel="true">
              <mat-option *ngFor="let option of filteredMotivations | async" [value]="option.value">
                {{option.display}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="one-third">
          <mat-form-field>
            <mat-label>Others Involved</mat-label>
            <input type="text" matInput formControlName="othersInvolvedId" [matAutocomplete]="autoOthers">
            <mat-icon matSuffix class="icon" *ngIf="!referralForm.get('othersInvolvedId').value">arrow_drop_down</mat-icon>
            <button
              matSuffix
              class="icon"
              *ngIf="referralForm.get('othersInvolvedId').value"
              mat-icon-button
              aria-label="Clear"
              (click)="onClear('othersInvolvedId')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoOthers="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'othersInvolvedOptions')" showPanel="true">
              <mat-option *ngFor="let option of filteredOthersInvolved | async" [value]="option.value">
                {{option.display}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Bullying</mat-label>
            <input type="text" matInput formControlName="bullyingId" [matAutocomplete]="autoBullying">
            <mat-icon matSuffix class="icon" *ngIf="!referralForm.get('bullyingId').value">arrow_drop_down</mat-icon>
            <button
              matSuffix
              class="icon"
              *ngIf="referralForm.get('bullyingId').value"
              mat-icon-button
              aria-label="Clear"
              (click)="onClear('bullyingId')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoBullying="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'bullyingOptions')" showPanel="true">
              <mat-option *ngFor="let option of filteredBullying | async" [value]="option.value">
                {{option.display}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="one-third">
          <mat-form-field>
            <mat-label>Basis of Bullying</mat-label>
            <input type="text" matInput formControlName="basisOfBullyingId" [matAutocomplete]="autoBasisBullying">
            <mat-icon matSuffix class="icon" *ngIf="!referralForm.get('basisOfBullyingId').value">arrow_drop_down</mat-icon>
            <button
              matSuffix
              class="icon"
              *ngIf="referralForm.get('basisOfBullyingId').value"
              mat-icon-button
              aria-label="Clear"
              (click)="onClear('basisOfBullyingId')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoBasisBullying="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'basisOfBullyingOptions')" showPanel="true">
              <mat-option *ngFor="let option of filteredBasisofBullying | async" [value]="option.value">
                {{option.display}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Previous Action Taken</mat-label>
            <input type="text" matInput formControlName="previousActionTakenId" [matAutocomplete]="autoActionTaken">
            <mat-icon matSuffix class="icon" *ngIf="!referralForm.get('previousActionTakenId').value">arrow_drop_down</mat-icon>
            <button
              matSuffix
              class="icon"
              *ngIf="referralForm.get('previousActionTakenId').value"
              mat-icon-button
              aria-label="Clear"
              (click)="onClear('previousActionTakenId')"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoActionTaken="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'previousActionTakenOptions')" showPanel="true">
              <mat-option *ngFor="let option of filteredPreviousActionTaken | async" [value]="option.value">
                {{option.display}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  </form>
  <form *ngIf="isReviewing" [formGroup]="referralReviewForm">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title class="card-title">Administration Section</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="admin-section-form-container">
          <div class="one-column-layout">
            <div>
              <mat-form-field>
                <mat-label>Incident Context</mat-label>
                <input type="text" matInput formControlName="incidentContextId" [matAutocomplete]="autoContext">
                <mat-icon matSuffix class="icon" *ngIf="!referralReviewForm.get('incidentContextId').value">arrow_drop_down</mat-icon>
                <button
                  matSuffix
                  class="icon"
                  *ngIf="referralReviewForm.get('incidentContextId').value"
                  mat-icon-button
                  aria-label="Clear"
                  (click)="onClearReview('incidentContextId')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #autoContext="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'incidentContextOptions')" showPanel="true">
                  <mat-option *ngFor="let option of filteredContext | async" [value]="option.value">
                    {{option.display}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Incident Context</mat-label>
                <input type="text" matInput formControlName="severityLevelId" [matAutocomplete]="autolevel">
                <mat-icon matSuffix class="icon" *ngIf="!referralReviewForm.get('severityLevelId').value">arrow_drop_down</mat-icon>
                <button
                  matSuffix
                  class="icon"
                  *ngIf="referralReviewForm.get('severityLevelId').value"
                  mat-icon-button
                  aria-label="Clear"
                  (click)="onClearReview('severityLevelId')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #autolevel="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'severityLevelOptions')" showPanel="true">
                  <mat-option *ngFor="let option of filteredLevel | async" [value]="option.value">
                    {{option.display}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Incident Context</mat-label>
                <input type="text" matInput formControlName="dueProcessId" [matAutocomplete]="autoProcess">
                <mat-icon matSuffix class="icon" *ngIf="!referralReviewForm.get('dueProcessId').value">arrow_drop_down</mat-icon>
                <button
                  matSuffix
                  class="icon"
                  *ngIf="referralReviewForm.get('dueProcessId').value"
                  mat-icon-button
                  aria-label="Clear"
                  (click)="onClearReview('dueProcessId')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #autoProcess="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'dueProcessOptions')" showPanel="true">
                  <mat-option *ngFor="let option of filteredProcess | async" [value]="option.value">
                    {{option.display}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="fitMatFormFieldDiv" *ngIf="!isPrintable">
              <mat-form-field appearance="outline" class="notes-text-area">
                <mat-label>Notes</mat-label>
                <textarea
                  matInput
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="2"
                  [formControl]="$any(referralForm.get('notes'))"
                  placeholder="Notes">
                </textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
  <mat-card *ngIf="isReviewing" class="disposition-card">
    <mat-card-header>
      <mat-card-title class="card-title">Hero Disposition</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-hero-disposition-view *ngIf="referral.heroDisposition.finalized" [heroDisposition]="referral.heroDisposition"></app-hero-disposition-view>
      <app-hero-disposition-edit *ngIf="!referral.heroDisposition.finalized"  [heroDisposition]="referral.heroDisposition" [form]="heroDispositionForm" [behaviorCodeOptions]="behaviorCodeOptions" [behaviorCodeReactionOptions]="behaviorCodeReactionOptions"></app-hero-disposition-edit>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="isReviewing && localDispositionForms" appearance="outlined" class="disposition-card">
    <mat-card-header>
      <mat-card-title class="card-title">Local Disposition</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="disposition-form-add-container">
        <mat-form-field class="full-width-input">
          <mat-label>Add Local Disposition</mat-label>
          <mat-select multiple (selectionChange)="multipleSelectionChange($event, 'local')" [formControl]="localDispositionsMultiselect">
            <mat-option *ngFor="let option of localDispositionOptions" [value]="option.value">
              {{ option.display }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="disposition-form-container" *ngFor="let id of Object.keys(localDispositionForms)">
        <app-disposition-edit [isPrintable]="isPrintable" (dispositionDeleted)="deleteDisposition(id)" [form]="localDispositionForms[id]" [dispositionOptions]="getDispositionOptions(id, 'local')" [durationOptions]="durationOptions"></app-disposition-edit>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="isReviewing && stateDispositionForms" appearance="outlined" class="disposition-card">
    <mat-card-header>
      <mat-card-title class="card-title">State Disposition</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="disposition-form-add-container">
        <mat-form-field class="full-width-input">
          <mat-label>Add State Disposition</mat-label>
          <mat-select multiple (selectionChange)="multipleSelectionChange($event, 'state')" [formControl]="stateDispositionsMultiselect">
            <mat-option *ngFor="let option of stateDispositionOptions" [value]="option.value">
              {{ option.display }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="disposition-form-container" *ngFor="let id of Object.keys(stateDispositionForms)">
        <app-disposition-edit [isPrintable]="isPrintable" (dispositionDeleted)="deleteDisposition(id)" [form]="stateDispositionForms[id]" [dispositionOptions]="getDispositionOptions(id, 'state')" [durationOptions]="durationOptions"></app-disposition-edit>
      </div>
    </mat-card-content>
  </mat-card>
</div>
